import { defineCopy } from "../intl";

import { ERRORS_COPY_EN_US } from "./en-us/errors.copy";
import { ERRORS_COPY_ES_ES } from "./es-es/errors.copy";

/** Mensagens padrão da hierarquia de erro (`errors.ts`). */
export const ERRORS_COPY_PT_BR = {
  network: "Não conseguimos falar com o servidor. Verifique sua conexão.",
  unauthorized: "Sua sessão expirou. Entre novamente.",
  forbidden: "Você não tem acesso a este recurso.",
  unexpectedResponse: (endpoint: string) =>
    `Resposta inesperada do servidor em ${endpoint}.`,
  generic: "Algo deu errado. Tente de novo.",
  passwordChangeRequired: "Troque sua senha para continuar.",
  legalAcceptanceRequired: "Aceite os Termos de Uso atualizados para continuar.",
  demoMode: "Isso é só um exemplo: nada foi salvo.",
  phoneNotVerified:
    "Confirme seu telefone antes de pedir a proposta — é por ele que a gente te avisa quando ela sair.",
} as const;

export const ERRORS_COPY = defineCopy(ERRORS_COPY_PT_BR, {
  "en-US": ERRORS_COPY_EN_US,
  "es-ES": ERRORS_COPY_ES_ES,
});
